import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { NewsService } from '../../Services/news.service';
import { Subscription } from 'rxjs';
import { Routes, RouterModule, Router, NavigationEnd } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-news-details',
  templateUrl: './news-details.component.html',
  styleUrls: ['./news-details.component.scss'],
  providers: [NewsService],
})
export class NewsDetailsComponent implements OnInit, OnDestroy {
  subscription = new Subscription();
  constructor(private newsService: NewsService, private route: ActivatedRoute, private router: Router, public sanitizer: DomSanitizer) { }
  blogdetail: any = [{
    Content: "",
    Title: "",
    Date: "",
    Description: ""
  }];
  blogseoname: any;
  blogsdate: any;
  isLoading: boolean = false;
  SafeURL: any;
  videourllist: any = [];

  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0)
    });
    this.route.paramMap.subscribe(params => {
      this.blogseoname = params.get('seoname');
    });

    this.getBlog(this.blogseoname);
  }

  getBlog(blogseoname) {
    this.isLoading = true;
    this.subscription = this.newsService.GetBlogData(blogseoname).subscribe(data => {
      this.isLoading = false;
      if (data != null) {
        this.blogdetail.Content = data.Response.Data.Content;
        this.blogdetail.Title = data.Response.Data.Seo.Title;
        this.blogdetail.Description = data.Response.Data.Seo.Description;

        data.Response.Data.VideoFileUrl.forEach(childObj => {
          childObj = this.sanitizer.bypassSecurityTrustResourceUrl(childObj);
          this.videourllist.push(childObj);
        })
      }
    }, err => {
      console.log('err in news-detail component', err);
      this.isLoading = false;
    });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
